"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerDayOfWeek = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _react = require("react");
var _typography = require("../../../typography");
var _DatePickerDayBox = require("./DatePickerDayBox");
var _datePickerTheme = require("./datePickerTheme");
// These don't change, so we can memoize them.
const DatePickerDayOfWeek = /*#__PURE__*/(0, _react.memo)((0, _styled.default)(_DatePickerDayBox.DatePickerDayBox)`
        color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _datePickerTheme.datePickerTheme.dayLabelColor(themeMode);
}};
        font-size: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _datePickerTheme.datePickerTheme.dayLabelFontSize(themeMode);
}};
        height: ${_designTokens.space.space60};
    `.withComponent(_typography.TypeRampV2));
exports.DatePickerDayOfWeek = DatePickerDayOfWeek;
DatePickerDayOfWeek.displayName = "DatePickerDayOfWeek";
//# sourceMappingURL=DatePickerDayOfWeek.js.map